let thumbSwipers = [];

function buildVariationsSlider() {
    thumbSwipers = [];

    if (!checkResolution('cxs;xs')) {
        $('.js-slider-variations').each(function () {
            let id = $(this).data('product-id');

            thumbSwipers.push({
                productId: id,
                slider: false,
                elem: $(this),
                active: false,
                query: false,
                tooltipOpen: false,
                options: {
                    simulateTouch: false,
                    allowTouchMove: true,
                    centerInsufficientSlides: true,
                    slidesPerView: 'auto',
                    spaceBetween: 6,
                    slideToClickedSlide: true,
                    loop: false,
                    roundLengths: true,
                    navigation: {
                        nextEl: '.js-slider-variations-next-' + id,
                        prevEl: '.js-slider-variations-prev-' + id,
                        disabledClass: 'is-disabled',
                        hiddenClass: 'is-hidden'
                    }
                }
            });
        });

        checkSliders(thumbSwipers);
    }
}

function changeThumbVariation(productId, data) {
    const $thumb = $('.js-product-thumb[data-id="' + productId + '"]');

    if ($thumb.length) {
        $thumb.removeClass('is-loading');

        if (data.status) {
            const product = data.item,
                variation = data.variation;

            let variation_values;

            $.each(data.variation.variation_values, function () {
                if ($.inArray(this.variation_id, [1, 3]) !== -1) {
                    variation_values = this;
                }
            });

            $thumb.find('.image-holder__item img').attr('src', Eshop.image(product.image_raw, 'sm'));
            $thumb.find('.js-thumb-price').html(Format.price(product.price_vat));
            $thumb.find('.js-thumb-variation-name').html(variation_values.name);
            $thumb.find('.js-ribbon-item.is-exposed').toggleClass('hidden', !data.variation.custom_is_exposed_at_store);
            $thumb.find('.js-thumb-link').attr('href', variation.link);
            $thumb.find('.js-thumb-availability')
                .css('color', product.status_color)
                .html(product.status);

            $thumb.find('.js-tippy').each(function() {
                if (this._tippy) {
                    this._tippy.destroy();
                }
            });

            if (product.status_description) {
                $thumb.find('.js-thumb-availability')
                    .append('<i class="ico ico-question"></i>')
                    .addClass('js-tippy')
                    .attr('title', product.status_description);

                $thumb.find('.js-tippy').each(function() {
                    tippy(this, {
                        arrow: true
                    });
                });
            } else {
                $thumb.find('.js-thumb-availability').removeClass('js-tippy')
            }

            checkCurrentVariation($thumb);
        } else {
            Eshop.alert(data.message, { 'type': 'danger' });
        }
    }
}

function checkCurrentVariation($thumb) {
    const productId = $thumb.data('id'),
        $variations = $thumb.find('input[name="variations[]"][data-product-id="' + productId + '"]'),
        variationValues = $variations.map(function () {
            return $(this).val();
        }).toArray();

    let selectedIndex = false;

    $.each(variationValues, function () {
        const $selectedButton = $thumb.find('.js-change-variation[data-value="' + this + '"]');

        if ($selectedButton.length) {
            $selectedButton.addClass('is-selected');

            selectedIndex = $selectedButton.parent().index();
        }
    });

    if (!checkResolution('cxs;xs') && selectedIndex !== false) {
        let slider = getThumbSwiperById(productId);

        if (slider) {
            slider.update();
            slider.slideTo(selectedIndex);
        }
    }
}

function getThumbSwiperById(id) {
    let slider = false;

    $.each(thumbSwipers, function () {
        if (this.productId == id) {
            if (this.slider) {
                slider = this.slider
                return false;
            }
        }
    });

    return slider;
}


$(document).on('click', '.js-change-variation', function () {
    const $wrapper = $(this).closest('.js-thumb-variations'),
        productId = $(this).data('product-id'),
        variationId = $(this).data('variation-id'),
        value = $(this).data('value'),
        $thumb = $('.js-product-thumb[data-id="' + productId + '"]');

    if (!$thumb.hasClass('is-loading')) {
        $thumb.addClass('is-loading');

        $('input[name="variations[]"][data-product-id="' + productId + '"][data-variation-id="' + variationId + '"]').val(value);

        const $variations = $wrapper.find('input[name="variations[]"][data-product-id="' + productId + '"]'),
            variationValues = $variations.map(function () {
                return $(this).val();
            }).toArray();

        $thumb.find('.js-change-variation').removeClass('is-selected');
        $thumb.find('.js-change-variation[data-value="' + value + '"]').addClass('is-selected');

        $.post('/catalog/get-product-variation/' + productId, { 'variation_values': variationValues }, function (data) {
            changeThumbVariation(productId, data);
        });
    }
});

$(document).on('mouseenter', '.js-product-thumb', function () {
    const id = $(this).data('id');

    if (typeof bLazy !== 'undefined') {
        bLazy.revalidate();
    }

    if (!checkResolution('cxs;xs')) {
        checkCurrentVariation($(this));
    }
});

rEvent.on('Listing.fetchedData', function (data) {
    if ($(document).find('.js-slider-variations').length) {
        buildVariationsSlider();
    }
});

$(function () {
    if ($(document).find('.js-slider-variations').length) {
        buildVariationsSlider();
    }
});
